import axios from "./request";
import { Log } from "./log";
const getUserInfo = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user || {};
};
export const AddSpecialist = params => {
  //添加专家
  const { img, name, territory, phone, introduce } = params;
  const { id } = getUserInfo();
  const data = new FormData();
  data.append("type", 1);
  data.append("img", img && img[0] ? img[0].url : "/specialist.jpg");
  data.append("name", name);
  data.append("territory", territory);
  data.append("phone", phone);
  data.append("introduce", introduce);
  data.append("amend_id", id);
  Log(`添加了专家${name}`);
  return axios.post("/specialist", data);
};
export const EditSpecialist = params => {
  //修改专家
  const { id, img, name, territory, phone, introduce } = params;
  const { id: amend_id } = getUserInfo();
  const data = new FormData();
  data.append("type", 2);
  data.append("id", id);
  data.append("img", img && img[0] ? img[0].url : "/specialist.jpg");
  data.append("name", name);
  data.append("territory", territory);
  data.append("phone", phone);
  data.append("introduce", introduce);
  data.append("amend_id", amend_id);
  Log(`修改了专家${name},id为${id}`);
  return axios.post("/specialist", data);
};
export const GetSpecialist = params => {
  //专家列表
  const { page, name, num } = params;
  const data = new FormData();
  data.append("page", page);
  data.append("name", name);
  data.append("num", num || 10);
  return axios.post("/specialist_list", data);
};
export const DeleteSpecialist = params => {
  //删除专家
  const { id } = params;
  const data = new FormData();
  data.append("id", id);
  Log(`删除了专家,id为${id}`);
  return axios.post("/specialist_del", data);
};
export const UploadSpeciallist = file => {
  //导入专家
  const { id } = getUserInfo();
  const data = new FormData();
  data.append("file", file);
  data.append("uid", id);
  Log(`批量导入了专家`);
  return axios.post("/uploading_specialist", data);
};



// WEBPACK FOOTER //
// ./src/request/specialist.js